<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/rotationbanner/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      :show="false"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
    >
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="position"
        label="位置"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="name"
        label="是否轮播"
        min-width="100"
        :formatter="typeCardWithdrawalStatus"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="name"
        label="状态"
        min-width="100"
        :formatter="typeStatus"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="190"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="190"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="realName"
        label="操作人"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button type="text" @click="configure(scope.row.id)"
            >配置
          </el-button>
          <el-button type="text" @click="openAddDialog(scope.row)"
            >修改
          </el-button>
          <el-button type="text" @click="handleStatus(scope.row)"
            >{{ scope.row.status == 0 ? "启用" : "禁用" }}
          </el-button>
          <!-- <el-button type="text" @click="handleDelete(scope.row)"
            >删除
          </el-button> -->
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      labelWidth="120px"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
    >
      <el-form-item label="位置" prop="position">
        <el-select
          v-model="dialogModel.position"
          clearable
          :disabled="positionshow"
        >
          <el-option
            v-for="item in bannerPosition"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否轮播" prop="enableRotation">
        <el-radio-group v-model="dialogModel.enableRotation">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
// 组件
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

// 接口
import APPService from "service/APPService";
import MallService from "service/MallService";
import MemberLevelService from "service/MemberLevelService";
// 时间
import TimeRange from "service/constant/TimeRange";
// 类别和状态
import EnableStatus from "service/constant/EnableStatus";
import privateKey from "service/constant/privateKey";
// 混合js
import {
  encrypt,
  urlEncode,
  objKeySort,
  debounce,
} from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
// 语法糖
import { mapGetters } from "vuex";

export default {
  name: "rotationbanner",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      positionshow: false,
      bannerPosition: [],
      formModel: {
        // time: "",
      },
      tableData: [],
      submitService: APPService.bannerList,
      page: {},
      isPage: false,
      itemId: "",
      dialogModel: {
        enableRotation: "",
        position: "",
      },
      dialogRules: {
        position: [
          {
            required: true,
            message: "请选择位置",
          },
        ],
        enableRotation: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      isFlag: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
    this.getTypeNames("banner位置", (res) => {
      this.bannerPosition = [...res];
    });
  },
  computed: {
    submitData() {
      // if (this.formModel.time == null || this.formModel.time == "") {
      //   this.formModel.time = [];
      // }
      this.params = {
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      // if (this.formModel.time.length) {
      //   // 0代表开始时间
      //   this.params.createTimeStart = this.formModel.time[0];
      //   // 1代表结束时间
      //   this.params.createTimeEnd = this.formModel.time[1];
      // }
      return this.params;
    },
    dialogData() {
      const params = {
        position: this.dialogModel.position,
        enableRotation: this.dialogModel.enableRotation,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId ? APPService.bannerEdit : APPService.bannerInsert;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {};

      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    // handleDelete(item) {
    //   this.showConfirm("确定删除该类别？")
    //     .then(() => {
    //       this.doDelete(item.id);
    //     })
    //     .catch(() => {});
    // },
    // doDelete(id) {
    //   this.doLoad(
    //     APPService.bannerDel,
    //     {
    //       id: id,
    //     },
    //     (res) => {
    //       this.doCheck(res, (res) => {
    //         this.commonSuccess(res);
    //       });
    //     },
    //     "操作失败"
    //   );
    // },
    handleStatus(item) {
      this.showConfirm(`确定${item.status == 0 ? "启用" : "禁用"}？`)
        .then(() => {
          this.doStatus(item);
        })
        .catch(() => {});
    },
    doStatus(item) {
      this.doLoad(
        APPService.bannerStatus,
        {
          id: item.id,
          status: item.status == "1" ? "0" : "1",
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    configure(item) {
      this.$router.push({
        name: "rotation",
        params: {
          item: item,
        },
      });
    },
    // 添假弹框打开
    openAddDialog(item) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.dialogModel.enableRotation = Number(
          this.dialogModel.enableRotation
        );
        this.positionshow = true;
      }
      this.$refs.formDialog.open();
      // 清空校验
      this.$nextTick(() => {
        this.$refs.formDialog.clearValidate();
      });
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    // 弹框关闭清空数据
    dialogClose() {
      this.dialogModel = {
        position: "",
        enableRotation: "",
      };
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    typeCardWithdrawalStatus: function (row, column) {
      switch (row.enableRotation) {
        case "0":
          return "否";
          break;
        case "1":
          return "是";
          break;
        default:
          return "--";
      }
    },
    typeStatus: function (row, column) {
      switch (row.status) {
        case "0":
          return "禁用";
          break;
        case "1":
          return "启用";
          break;
        default:
          return "--";
      }
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/RotationBanner.vue